import { render, staticRenderFns } from "./paiBianContent.vue?vue&type=template&id=0391be52&scoped=true"
import script from "./paiBianContent.vue?vue&type=script&lang=js"
export * from "./paiBianContent.vue?vue&type=script&lang=js"
import style0 from "./paiBianContent.vue?vue&type=style&index=0&id=0391be52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391be52",
  null
  
)

export default component.exports